import { useTranslation } from "react-i18next";
import { Button, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Text, List, ListItem, Box } from "@chakra-ui/react"

interface props {
    isModalOpen: boolean;
    title: string;
    yesBtnText?: string;    
    noBtnText?: string;
    message: string;
    yesMessage: string;
    noMessage: string;
    onYes: () => void;
    onNo: () => void;
}

export const YesNoBoxModal = ({ isModalOpen, title, yesBtnText, noBtnText, message, yesMessage, noMessage, onYes, onNo }: props) => {
const { t, i18n } = useTranslation("translation");
    return (
        <Modal
            closeOnOverlayClick={false}
            isOpen={isModalOpen}
            onClose={onNo}
            size='sm'>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader className='!font-bold lg'>{title}</ModalHeader>
                <ModalCloseButton />

                <ModalBody pb={6}>
                    {message.split('\n').map((line, index) => (
                        <div key={index}>{line}</div>
                    ))}

                    <List spacing={2} mt={4}>
                        <ListItem display="flex" alignItems="center">
                            <Box as="span" color="orange.500" fontSize="xl" mr={2}>•</Box>
                            <Text>
                                {t("app.click")} <Text as="b" display="inline">{noBtnText || '取消 '}</Text>{noMessage}
                            </Text>
                        </ListItem>
                        <ListItem display="flex" alignItems="center">
                            <Box as="span" color="#1DA1F2" fontSize="xl" mr={2}>•</Box>
                            <Text>
                                {t("app.click")} <Text as="b" display="inline">{yesBtnText || '確定 '}</Text>{yesMessage}
                            </Text>
                        </ListItem>
                    </List>
                </ModalBody>

                <ModalFooter className="gap-4">
                    <Button colorScheme="orange" className="w-full" onClick={onNo}>
                        {noBtnText || '取消'}
                    </Button>
                    <Button colorScheme="twitter" className="w-full" onClick={onYes}>
                        {yesBtnText || '確定'}
                    </Button>
                </ModalFooter>

            </ModalContent>
        </Modal>
    )
}